import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { useToast } from '@/hooks/use-toast';
import { atualizarRotina, mensagemDeErro, type Rotina } from '@/services/api/rotinas';

export default function RenomearDialog({ rotina, open, onOpenChange }: {
    rotina: Rotina; open: boolean; onOpenChange: (o: boolean) => void;
}) {
    const { toast } = useToast();
    const queryClient = useQueryClient();
    const [nome, setNome] = useState(rotina.nome);
    const salvar = useMutation({
        mutationFn: () => atualizarRotina(rotina.id, { nome: nome.trim() }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['rotinas-agendamento'] });
            queryClient.invalidateQueries({ queryKey: ['rotina-agendamento', rotina.id] });
            onOpenChange(false);
            toast({ title: 'Rotina renomeada' });
        },
        onError: (e) => toast({
            variant: 'destructive', title: 'Não foi possível renomear',
            description: mensagemDeErro(e, 'Tente de novo.'),
        }),
    });
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle>Renomear Rotina</DialogTitle>
                    <DialogDescription>
                        O nome só serve para você distinguir as Rotinas do mesmo dia. Não entra no título dos
                        broadcasts — esse vem do título de cada grupo.
                    </DialogDescription>
                </DialogHeader>
                <Input value={nome} maxLength={160} onChange={(e) => setNome(e.target.value)} />
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)} disabled={salvar.isPending}>Cancelar</Button>
                    <Button onClick={() => salvar.mutate()} disabled={!nome.trim() || nome.trim() === rotina.nome || salvar.isPending}>
                        {salvar.isPending && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}
                        Salvar
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
